import Views from "@/views";
import Layout from "@/components/Layouts/Index.vue";

/* Views */
const { countriesView, departmentsView, statesView } = Views;

const locationRouter = {
  path: "/location",
  component: Layout,
  redirect: "dashboard",
  name: "",
  history: false,
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: "countries",
      name: "Countries",
      component: countriesView,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "departments",
      name: "Departments",
      component: departmentsView,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "states",
      name: "States",
      component: statesView,
      meta: {
        requiresAuth: true,
      },
    },
  ],
};

export default locationRouter;
